import styled from 'styled-components'

export const EvaluationCompleteWrapper = styled.div`
  padding: 0 8px;
`
